import React from 'react';
import { Link } from 'react-router-dom';

import {Sidebar} from '../component/includes/Sidebar';
export const Wrapper = ({children}) => {
  return (
    <>
  		<Sidebar pathname={children.props.location.pathname} year = {children.props.match.params.year} name = {children.props.match.params.name}  />
  		<div className="content">
		    <Link to="/"><img src={process.env.PUBLIC_URL+"/logo.png"} /></Link><br />
		    {children}
	    </div>
	   
    </>
  )  
}  

